import { Injectable } from '@angular/core';
import { Cargo } from 'src/app/website/pages/empresa/entities/cargo';
import { CRUDService } from 'src/app/website/pages/core/services/crud.service';
import { endPoints } from 'src/environments/environment';
import { HttpInt } from 'src/app/httpInt';
import { MensajeUsuarioService } from '../../comun/services/mensaje-usuario.service';

@Injectable({
  providedIn: 'root',
})
export class CargoService extends CRUDService<Cargo> {
  empresaId: any;

  constructor(
    public override httpInt: HttpInt,
    public override mensajeUsuarioService: MensajeUsuarioService,
  ) {
    super(httpInt, mensajeUsuarioService);
    this.end_point = endPoints.CargoService;
  }

  findByEmpresaid(empresaId: any) {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}empresa/${empresaId}`).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          this.manageError(err);
          reject(err);
        },
      );
    });
  }
  findByEmpresa() {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}empresa`).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          this.manageError(err);
          reject(err);
        },
      );
    });
  }

  /**
   * Obtener cargos para una empresa específica (acepta id directo)
   */
  findByEmpresaId(empresaId: number) {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}empresa/${empresaId}`).subscribe(
        (res) => resolve(res),
        (err) => {
          this.manageError(err);
          reject(err);
        },
      );
    });
  }

  getClassName(): string {
    return 'CargoService';
  }
}
